import CCE_BLOCKS from './Blocks/Coffee'
export default {
    id: 2,
    name: 'Coffee',
    container: true,
    container_width: 750,
    container_background_color: '#cccccc',
    background_color: '#cccccc',
    blocks: CCE_BLOCKS
}